<template>
  <div>
    <h1>{{ $t("travelService.chooseOfferForm.title") }}</h1>
    <fieldset
      class="custom-fieldset"
      :key="item.id"
      v-for="(item, itemIndex) of allOffer.items"
      :class="{
        'fieldset-warning': item.status === itemsStatus.STATUS_CLIENT_REQUEST_BOOKING_CANCEL,
        'fieldset-error': item.status === itemsStatus.STATUS_BOOKING_CANCELLED
      }"
    >
      <legend>
        {{ $t("travelService.chooseOfferForm.service") }} {{ itemIndex + 1 }} -
        {{ $t("travelService.types." + item.type) }}
        <template v-if="item.status === itemsStatus.STATUS_CLIENT_REQUEST_BOOKING_CANCEL">
          ({{ $t("travelService.singleServiceOrderStatus.requestBookingCancel") }})
        </template>
        <template v-if="item.status === itemsStatus.STATUS_BOOKING_CANCELLED"> ({{ $t("travelService.singleServiceOrderStatus.bookingCanceled") }}) </template>
      </legend>
      <v-row>
        <v-col md="10" v-if="item.selectedOffer.html != null && item.selectedOffer.html.length !== 0">
          <w-y-s-i-w-y-g-html-element :html="item.selectedOffer.html" />
        </v-col>
        <v-col md="10" v-if="item.type === 'hotel' && (item.selectedOffer.html == null || item.selectedOffer.html.length === 0)" cols="12">
          <hotel-response-presentation :offer="item.selectedOffer" />
        </v-col>
        <v-col md="10" v-if="item.type === 'car' && (item.selectedOffer.html == null || item.selectedOffer.html.length === 0)" cols="12">
          <car-response-presentation :offer="item.selectedOffer" />
        </v-col>
        <v-col md="10" v-if="item.type === 'flight' && (item.selectedOffer.html == null || item.selectedOffer.html.length === 0)" cols="12">
          <flight-response-presentation :offer="item.selectedOffer" />
        </v-col>
        <v-col md="10" v-if="item.type === 'rail' && (item.selectedOffer.html == null || item.selectedOffer.html.length === 0)" cols="12">
          <rail-response-presentation :offer="item.selectedOffer" />
        </v-col>

        <v-col class="pl-3" md="2" cols="12">
          <v-text-field :label="$t('global.amount')" :value="item.selectedOffer.price + ' ' + item.selectedOffer.currency" outlined readonly />
          <v-text-field
            :label="$t('travelService.chooseOfferForm.costCentreFullName')"
            outlined
            readonly
            v-if="$store.state.Auth.userProperties.system_settings.cost_centre_on_delegations !== settingTypes.NOT_AVAILABLE"
            v-model="item.cost_centre"
          />

          <div class="text-center my-3" style="width: 100%">
            <v-icon color="primary" style="font-size: 100px">{{ bookingIconType(item.type) }}</v-icon>
          </div>
        </v-col>
      </v-row>
      <travel-users-inline-form
        :available-users="availableUsers"
        :readonly="true"
        :required-props="getRequiredProps(item)"
        :users="item.users"
        @saved="downloadAvailableUsers()"
      />
      <fieldset v-if="item.selectedOffer.files.length > 0" class="custom-fieldset">
        <legend>{{ $t("travelService.filesAttachedAtBooking") }}</legend>
        <multiple-file-download :files="item.selectedOffer.files" @download="fileId => downloadBookingFile(fileId)" />
      </fieldset>
      <ClientViewOfferHistory :offers="[item.selectedOffer]" />
      <message-list :travel-service-order-item-id="item.id" :travel-service-order-id="$route.params.id" :start-messages="item.messages" class="mb-3" />
      <h3>{{ $t("travelService.outdatedOffers") }}:</h3>
      <span v-for="historyItem of item.selectedOffer.history" :key="historyItem.id">
        <offer-archive-dialog :type="item.type" :id="historyItem.id" :is-admin="false">
          {{ historyItem.last_edit_at }} {{ historyItem.last_edit_by_name }} <v-btn icon><v-icon>remove_red_eye</v-icon></v-btn>
        </offer-archive-dialog>
      </span>
    </fieldset>

    <h3 v-if="!$store.getters['Ajax/loading']">
      {{ $t("global.sum") }}:
      <template v-for="cost in summaryDataTableCost"> {{ cost.value }} {{ cost.currency }} </template>
      <template v-if="summaryDataTableCost.length === 0"> 0. {{ $t("travelService.noServicesSelectedToOrder") }} </template>
    </h3>

    <!--        <v-card>-->
    <v-card-actions>
      <v-spacer />
      <v-btn @click.native="cancel()" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
    </v-card-actions>
    <!--        </v-card>-->
  </div>
</template>

<script>
import { settingTypes } from "../../staticData/SettingsTypes";
import HotelResponsePresentation from "../../components/TravelService/OfferPresentation/HotelResponsePresentation";
import CarResponsePresentation from "../../components/TravelService/OfferPresentation/CarResponsePresentation";
import FlightResponsePresentation from "../../components/TravelService/OfferPresentation/FlightResponsePresentation";
import RailResponsePresentation from "../../components/TravelService/OfferPresentation/RailResponsePresentation";
import TravelUsersInlineForm from "../../components/TravelService/TravelUsersInlineForm";
import WYSIWYGHtmlElement from "../../components/Shared/WYSIWYGHtmlElement";
import downloadFile from "../../repository/downloadFile";
import ClientViewOfferHistory from "../../components/TravelService/ClientViewOfferHistory";
import MultipleFileDownload from "../../components/MultipleFileDownload";
import MessageList from "../../components/MessageList";
import { itemsStatus } from "../../staticData/ServiceOrder";
import OfferArchiveDialog from "../../components/TravelService/OfferArchiveDialog";

export default {
  name: "TravelServiceBookedView",
  components: {
    OfferArchiveDialog,
    MessageList,
    MultipleFileDownload,
    ClientViewOfferHistory,
    WYSIWYGHtmlElement,
    TravelUsersInlineForm,
    RailResponsePresentation,
    FlightResponsePresentation,
    CarResponsePresentation,
    HotelResponsePresentation
  },
  data: () => ({
    itemsStatus,
    allOffer: {
      items: []
    },
    availableUsers: [],
    settingTypes
  }),
  created() {
    this.axios
      .get("/travel-service/get-booked", {
        params: { id: this.$route.params.id }
      })
      .then(resp => {
        if (typeof resp.data.status != "undefined" && resp.data.status === "WRONG_STATUS") {
          this.$router.push("/travel-service");
        }
        this.allOffer = resp.data;
      });
    this.downloadAvailableUsers();
  },
  computed: {
    summaryDataTableCost() {
      let result = [];
      if (this.allOffer == null) return result;
      for (let offerItem of this.allOffer.items) {
        if (offerItem.selectedOffer !== null) {
          let oldCurrencyRow = result.find(v => v.currency === offerItem.selectedOffer.currency);
          if (typeof oldCurrencyRow != "undefined") {
            oldCurrencyRow.value += offerItem.selectedOffer.price;
          } else {
            result.push({
              currency: offerItem.selectedOffer.currency,
              value: offerItem.selectedOffer.price
            });
          }
        }
      }
      return result;
    },
    userList() {
      let result = [];
      for (let user of this.availableUsers) {
        result.push({ text: user.name + " " + user.surname, value: user.id });
      }
      return result;
    }
  },
  methods: {
    downloadAvailableUsers() {
      this.axios.get("/travel-service/get-available-users").then(resp => {
        this.availableUsers = resp.data;
      });
    },
    downloadBookingFile(id) {
      downloadFile("travel-service/download-booking-file?fileId=" + id);
    },
    bookingIconType(bookingType) {
      if (bookingType === "flight") return "fa-plane";
      if (bookingType === "car") return "fa-car";
      if (bookingType === "hotel") return "fa-hotel";
      if (bookingType === "rail") return "fa-subway";
      if (bookingType === "other") return "fa-suitcase";
      if (bookingType === "insurance") return "fa-clinic-medical";
    },
    cancel() {
      this.$router.push("/travel-service");
    },
    getRequiredProps(orderItem) {
      let result = {
        is_birth_date_required: 0,
        is_document_number_required: 0,
        is_document_expire_required: 0,
        is_email_required: 0,
        is_phone_required: 0,
        is_middle_name_required: 0,
        is_nationality_required: 0,
        is_document_issue_place_required: 0,
        is_residence_address_required: 0
      };
      for (let propertyName in result) {
        result[propertyName] = orderItem.selectedOffer[propertyName];
      }
      // for (let propertyName in result) {
      //     result[propertyName] = orderItem.returnSelectedOffer[propertyName] === 1 ? 1 : result[propertyName];
      // }

      return result;
    }
  }
};
</script>

<style scoped />
